module.exports = __webpack_public_path__ + "static/img/beijing3.6c745ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/lunbo/beijing3.png
// module id = /qdB
// module chunks = 6